import Modal from 'components/Modal'
import Button from 'components/Button'

import { useTourContext } from 'context/TourContext'
import { useAuthContext } from 'context'

export default function NoteModal(props) {
  const {
    modify,
    isOpened,
    handleClose,
    handleSaveGrid,
    textAreaRef,
    note,
    handleChangeNote,
    handleUpdateNote,
  } = props

  const { handleNextTourStep, handleFocusTour } = useTourContext()
  const { userDetails } = useAuthContext()

  return (
    <Modal
      title="Notiță grilă (opțional)"
      isOpen={isOpened}
      closeModal={handleClose}
    >
      <textarea
        value={note}
        onChange={handleChangeNote}
        ref={textAreaRef}
        className="min-w-[300px] bg-container-background w-full min-h-[80px] max-h-[200px] border-zinc-950 mt-[10px] p-[10px] text-xs border-solid rounded border-[1px] outline-none"
      />
      <Button
        className="bg-primary mt-[10px] px-[20px]"
        id="save-note-btn"
        onClick={() => {
          modify ? handleUpdateNote() : handleSaveGrid()
          handleClose()
          if (!userDetails?.tutorial) {
            handleNextTourStep()
            handleFocusTour()
          }
        }}
      >
        Salvează
      </Button>
    </Modal>
  )
}
